module.exports = __webpack_public_path__ + "static/61548020_1350173741799847_7294826872209145856_n_optimized-64081ca8f946e71553f0293f63f990f9.jpg";